<template>
<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <StatusForm v-if="status" :status="status" />
    <LoadingPage v-if="!status"/>
  </PageRowWrapper>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import StatusForm from '@/components/settings/stock-registers/status/StatusForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'StatusEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    StatusForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      status: state => state.status.statusById
    })
  },
  methods: {
    ...mapActions('status', ['fetchById', 'cleanState'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  },
  destroyed () {
    this.cleanState()
  }
}
</script>
